import { Options, OptionsQuery } from '@shared/ui/components/Select';

import { getFrequentPassageStickerTypes } from './getFrequentPassageStickerTypes';

export function getFrequentPassageStickerTypeOptionsForEvent(
  eventId: number,
  { search, value }: OptionsQuery
): Promise<Options> {
  return getFrequentPassageStickerTypes({
    filter: { name: search, id: value, event_id: eventId },
    page: { size: 50 },
  }).then(({ data }) =>
    data.map((stickerType) => ({
      label: stickerType.name,
      value: stickerType.id,
    }))
  );
}
